const FontSize = {
  large: "36px",
  medium: "20px",
  default: "16px",
  small: "12px",
};

export default FontSize;
